export const Constants = {
  PASSWORD_PATTERN: /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
  PASSWORD_VALIDATION_MESSAGE:
    'The password must contain digits, lowercase and uppercase characters',
  DEFAULT_ERROR_MESSAGE: 'Something went wrong'
} as const;